import heic2any from "heic2any";

/**
 * Formats a number with K/M suffixes for better readability
 * @param count - The number to format
 * @returns Formatted string (e.g., "1.5k", "2M", "500")
 */
export function formatNumber(count: number): string {
  if (count >= 1000000) {
    return (count / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (count >= 1000) {
    return (count / 1000).toFixed(1).replace(/\.0$/, "") + "k";
  }
  return count.toString();
}

/**
 * Alias for formatNumber - specifically for star counts
 */
export const formatStarCount = formatNumber;

export async function convertToJpeg(file, quality = 0.9): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      if (!ctx) {
        resolve(file);
        return;
      }
      ctx.drawImage(img, 0, 0);

      canvas.toBlob(
        blob => {
          if (!blob) return reject("Conversion failed");
          resolve(
            new File([blob], file.name.replace(/\.\w+$/, ".jpg"), {
              type: "image/jpeg",
            })
          );
        },
        "image/jpeg",
        quality
      );

      URL.revokeObjectURL(url);
    };

    img.onerror = reject;
    img.src = url;
  });
}

export async function normalizeImage(file: any): Promise<Blob> {
  if (file.type === "image/heic" || file.type === "image/heif") {
    const blob = await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: 0.9,
    });

    const workingBlob: Blob = Array.isArray(blob) ? blob[0] : blob;

    return new File([workingBlob], file.name.replace(/\.\w+$/, ".jpg"), {
      type: "image/jpeg",
    });
  }

  return convertToJpeg(file);
}
